<section class="b2b-banner" *ngIf="data">
    <div class="b2b-banner__inner">
        <div class="b2b-banner__image">
            <img [src]="data.banner_primary_image?.url || '/assets/images/frame.png'" [alt]="data.banner_primary_image?.alt || 'Ambiente corporativo com purificadores de água Everest'">
        </div>
        <div class="b2b-banner__frame"></div>
        <div class="b2b-banner__content">
            <h2 class="b2b-banner__content--title" [innerHTML]="data.banner_primary_title"></h2>
            <p class="b2b-banner__content--subtitle" [innerHTML]="data.banner_primary_subtitle"></p>
            <div class="b2b-banner__content--wrapper-items">
                <div class="b2b-banner__content--wrapper-items__item" *ngFor="let item of data.differentials; let i = index">
                    <img [src]="item.image?.url" alt="">
                    <span>{{ item.text }}</span>
                </div>
            </div>
            <a
                [href]="primaryHref"
                (click)="scrollToForm($event)"
                class="b2b-banner__content--button"
            >
                {{ data.banner_primary_label }}
            </a>
        </div>
    </div>
</section>
